var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-display--wrapper" }, [
    _c("div", { staticClass: "product-display" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "product-display__images" },
          [
            _c(
              "swiper",
              {
                ref: "mySwiper",
                staticClass: "swiper",
                attrs: { options: _vm.swiperOptions },
              },
              [
                _vm._l(_vm.imagesList, function (item, index) {
                  return _c(
                    "swiper-slide",
                    { key: item.id, staticClass: "product-display__slide" },
                    [
                      _c("img", {
                        attrs: { src: item.src, "image-id": item.id },
                      }),
                    ]
                  )
                }),
                _c("div", {
                  staticClass: "swiper-button-prev",
                  attrs: { slot: "button-prev" },
                  slot: "button-prev",
                }),
                _c("div", {
                  staticClass: "swiper-button-next",
                  attrs: { slot: "button-next" },
                  slot: "button-next",
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c("div", { staticClass: "product-display__content" }, [
          _c("div", { staticClass: "product-display__heading" }, [
            _c("h1", { domProps: { innerHTML: _vm._s(_vm.title) } }),
            _vm.product
              ? _c(
                  "div",
                  { staticClass: "product-display__options" },
                  [
                    _c("product-form", {
                      attrs: {
                        product: _vm.product,
                        variants: _vm.variants,
                        bundle: _vm.bundle,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "product-display__description" }, [
            _vm.description
              ? _c("p", { domProps: { innerHTML: _vm._s(_vm.description) } })
              : _vm._e(),
          ]),
          _vm.moreDetails.length > 0
            ? _c("div", { staticClass: "product-display__moreDetails" }, [
                _c(
                  "div",
                  { staticClass: "product-display__moreDetails__body" },
                  [
                    _c(
                      "span",
                      {
                        class: { close: _vm.openMoreDetails },
                        on: { click: _vm.openDetails },
                      },
                      [_vm._v("More Details")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "details",
                        class: { open: _vm.openMoreDetails },
                      },
                      _vm._l(_vm.moreDetails, function (item, index) {
                        return _c("div", { key: item.id }, [
                          _c("h2", [_vm._v(_vm._s(item.title))]),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(item.description) },
                          }),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }